import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { v7 } from 'uuid'

const initialState: notifications.InitialState = {
  notifications: []
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<notifications.BaseNotification>) => {
      state.notifications.push({ id: v7(), ...action.payload })
    },
    removeNotification: (state, action: PayloadAction<{ notificationId: string }>) => {
      state.notifications = state.notifications.filter(n => n.id !== action.payload.notificationId)
    }
  }
})

export const { addNotification, removeNotification } = notificationsSlice.actions
export const selectNotifications = (state: RootState) => state.notifications.notifications

export default notificationsSlice.reducer